import { nanoid } from 'nanoid'

export const getId = (...params) => nanoid(...params)
